export default __webpack_public_path__ + "static/media/learning-iterating-template.2f2afe76.pdf";